import { render, staticRenderFns } from "./searchinfor.html?vue&type=template&id=2bb01d4c&scoped=true&"
import script from "./searchinfor.js?vue&type=script&lang=js&"
export * from "./searchinfor.js?vue&type=script&lang=js&"
import style0 from "./searchinfor.sass?vue&type=style&index=0&id=2bb01d4c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb01d4c",
  null
  
)

component.options.__file = "searchinfor.vue"
export default component.exports